import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const elementId = hash.slice(1);

      // Wait a tick so the target section has time to render before scrolling.
      const frameId = window.requestAnimationFrame(() => {
        const target = document.getElementById(elementId);
        if (target) {
          target.scrollIntoView({ block: "start", behavior: "auto" });
        }
      });

      return () => window.cancelAnimationFrame(frameId);
    }

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, search, hash]);

  return null;
};

export default ScrollToTop;
